/** @file useSlotViews: the server's slot views by key, fetched again only when the set of slots changes. */
import { useEffect, useState } from 'react';
import type { ArtDeps, SlotViewAngles } from './artTypes';

/**
 * `deps.slots(puppetId)` turned into `key -> view`; refetched when `puppetId` or `shape` (a string naming the slot
 * keys) changes, so filling a slot does not refetch. Empty while loading or when the call fails.
 */
export function useSlotViews(deps: Pick<ArtDeps, 'slots'>, puppetId: string | null, shape: string): ReadonlyMap<string, SlotViewAngles> {
  const [views, setViews] = useState<ReadonlyMap<string, SlotViewAngles>>(new Map());
  useEffect(() => {
    if (puppetId === null) return undefined;
    let live = true;
    deps.slots(puppetId).then(
      (reply) => { if (live) setViews(new Map(reply.slots.map((s) => [s.key, s.view]))); },
      () => { if (live) setViews(new Map()); },
    );
    return () => { live = false; };
  }, [deps, puppetId, shape]);
  return views;
}
